<template>
    <div id="app">
        <v-app dark id="inspire">
        <v-navigation-drawer
            v-model="drawer"
            fixed
            app>
            <v-list dense>
                <v-list-group no-action>
                    <v-list-tile slot="activator">
                        <v-list-tile action>
                            <v-icon>dashboard</v-icon>
                        </v-list-tile>
                        <v-list-tile-content>
                            <v-list-tile-title>Dashboard</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                        <template v-for="(item,index) in dashsubgroup_items">
                            <v-list-tile :key="index" :to="item.route">
                            <v-list-tile-content>
                                <v-list-tile-title>{{item.title}}</v-list-tile-title>
                            </v-list-tile-content>
                            </v-list-tile>
                        </template>
                </v-list-group>
                <template v-for="(item,index) in items">
                    <v-list-tile :key="index" :to="item.route">
                    <v-list-tile-action>
                        <v-icon>{{item.icon}}</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>{{item.title}}</v-list-tile-title>
                    </v-list-tile-content>
                    </v-list-tile>
                </template>
                <v-divider></v-divider>
                <v-list-group no-action>
                    <v-list-tile slot="activator">
                        <v-list-tile action>
                            <v-icon>settings</v-icon>
                        </v-list-tile>
                        <v-list-tile-content>
                            <v-list-tile-title>Settings</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                        <template v-for="(item,index) in subgroup_items">
                            <v-list-tile :key="index" :to="item.route">
                            <v-list-tile-content>
                                <v-list-tile-title>{{item.title}}</v-list-tile-title>
                            </v-list-tile-content>
                            </v-list-tile>
                        </template>
                </v-list-group>
            </v-list>
        </v-navigation-drawer>
        <v-toolbar class="cardBackground" dark fixed app>
            <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
            <v-toolbar-title>Phoenix Equipment Manager</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn flat="flat" @click="logout">
                    <span>Log out</span>
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <router-view></router-view>
        <v-footer class="cardBackground" app>
            <span class="white--text">&copy; Thinxtra</span>
        </v-footer>
        </v-app>
    </div>
</template>

<script>
export default {
    data () {
        return {
            drawer: null,
            items: [            
                // {
                // title: "Manual Warehouse Transfer",
                // route: { name: "manualWT"},
                // icon: "list_alt"
                // },
                // {
                // title: "Manual Site Install",
                // route: { name: "manualSI"},
                // icon: "build"
                // },
                {
                title: "Reporting",
                route: { name: "Reporting"},
                icon: "assignment"
                },
                // {
                // title: "Manual Stock Adjustment",
                // route: { name: "ManualSA"},
                // icon: "assignment"
                // },
                {
                title: "Stock Transmutation",
                route: { name: "transmutation"},
                icon: "build"
                },
            ],
            dashsubgroup_items: [
                {
                title: "High Value Items",
                route: { name: "highvalue"},
                }, 
                {
                title: "Equipment Stock (Working)",
                route: { name: "mainstock"},
                }, 
                {
                title: "Subcontractor Stock",
                route: { name: "subco"},
                },                       
            ],
            subgroup_items: [
                {
                title: "Alerts",
                route: { name: "alerts"},
                },       
                {
                title: "Admin",
                route: { name: "admin"},
                },    
                {
                title: "Duplicates",
                route: { name: "dupes"},
                },       
            ]
        }
    },
    methods: {
        logout () {
            document.cookie = `sitePass=;path=/;domain=.thinxtra.com;
expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
           window.location.reload(); 
        }
    }
}
</script>

<style scoped>
.cardBackground {
  background-image: linear-gradient(to top right,#212121,#212121);
  box-shadow: 10px 10px 10px rgba(142, 123, 132, 0.1);
  border-radius: 4px;
}
</style>


// WEBPACK FOOTER //
// src/views/baseView.vue